import React from 'react'
import { rootReducer } from '../common/reducer'
import { createBrowserHistory } from 'history'
import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'
import { routerMiddleware } from 'connected-react-router'
import rootSaga from '../sagas'
import { applyMiddleware, createStore } from 'redux'

export const history = createBrowserHistory({ basename: process.env.PUBLIC_URL })
const middlewares = []

const sagaMiddleware = createSagaMiddleware()
middlewares.push(routerMiddleware(history))
middlewares.push(sagaMiddleware)
middlewares.push(logger)

export const store = createStore(rootReducer(history), applyMiddleware(...middlewares))

sagaMiddleware.run(rootSaga)
